// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`EditOrderAssets/styles/_main.scss`));
}

export {
  importCss ,
  
}
/* No side effect */
